import { Empty, Flex } from 'antd'
import clsx from 'clsx'
import React, { ReactNode } from 'react'

// The shared reading-list surface: a quiet bordered container whose children
// are divided rows. Used wherever a small collection reads better as lines than
// as an Ant Table (templates, phone numbers, …).
export type ListContainerProps = {
    isEmpty?: boolean
    emptyText?: ReactNode
    children?: ReactNode
    className?: string
}

export function ListContainer({ isEmpty, emptyText, children, className }: ListContainerProps) {
    return (
        <div className={clsx('overflow-hidden rounded-xl border border-hairline bg-white', className)}>
            {isEmpty ? (
                <Flex
                    justify="center"
                    className="py-10"
                >
                    <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description={emptyText}
                    />
                </Flex>
            ) : (
                children
            )}
        </div>
    )
}
